import { QueryCache, QueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

const queryCache = new QueryCache({
  onError: (error: unknown) => {
    console.error(error);
  }
});

export const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        const errorResponse = error as AxiosError;

        if (errorResponse.response?.status === 401) return false;

        return failureCount < 1;
      },
      retryDelay: 500,
      refetchOnWindowFocus: false
    }
  }
});

export function getMockQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false
      }
    }
  });
}
